<mat-dialog-actions class="justify-content-between">
    <h4 class="f-s-16 f-w-600">
        Payment
    </h4>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="paymentForm">
        <div class="row m-t-10">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.BILL_NO' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.BILL_NO' | translate }}" formControlName="billno"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBillSelected($event)">
                        <mat-option *ngFor="let bill of filteredBills | async" [value]="bill">
                            {{ bill.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="picker" required placeholder="DD/MM/YYYY" name="Billdate"
                        formControlName="paymentdate" [max]="maxDate">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> {{ 'LABEL.CHARGE_LABEL' | translate }}</mat-label>
                    <input matInput placeholder="Charge" formControlName="billAmount" readonly>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.PENDING_AMOUNT' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.PENDING_AMOUNT' | translate }}"
                        formControlName="pendingAmount" readonly>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> {{ 'LABEL.AMOUNT' | translate }}</mat-label>
                    <input matInput placeholder=" {{ 'LABEL.AMOUNT' | translate }}" formControlName="amount">
                    <mat-error *ngIf="paymentForm.get('amount')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="paymentForm.get('amount')?.hasError('exceedPending')">
                        {{ 'VALIDATION.AMOUNT_PENDING' | translate }}
                    </mat-error>
                    <mat-error *ngIf="paymentForm.get('amount')?.hasError('invalidDecimal')">
                        {{ 'VALIDATION.INVALID_DECIMAL' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.PAYMENT_TYPE' | translate }}</mat-label>
                    <mat-select formControlName="PaymentTypeId" (selectionChange)="onPaymentTypeSelected($event.value)"
                        required>
                        <mat-option *ngFor="let item of paymentType" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="paymentForm.get('PaymentTypeId')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-12" *ngIf="isTransaction">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> {{ 'LABEL.TRANSACTION_NO' | translate }}</mat-label>
                    <input matInput placeholder=" {{ 'LABEL.TRANSACTION_NO' | translate }}"
                        formControlName="TransactionNumber">
                    <mat-error *ngIf="paymentForm.get('TransactionNumber')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DESCRIPTION_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}" cols="5" rows="3"
                        formControlName="description"></textarea>
                </mat-form-field>
            </div>

        </div>

    </form>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row justify-content-between m-b-10">
        <div class="col-sm-12 text-right">
            <a mat-stroked-button color="primary" class="m-r-10" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </a>
            <button mat-flat-button color="primary" (click)="onSavePayment()" [disabled]="paymentForm.invalid">
                {{('BUTTON.BTN_SAVE' | translate) }}
            </button>
        </div>
    </div>
</mat-dialog-actions>